import type { SpeakingMode, SpeakingPart } from '@ielts-buddy/shared'
import { create } from 'zustand'

export type { SpeakingMode, SpeakingPart }

export type BottomTab = 'home' | 'results' | 'leaderboard' | 'profile'

/**
 * In-app screen routing.
 *
 * Tab screens share the bottom nav; speaking flows hide it until the user
 * returns to a tab.
 */
export type Screen =
  | { name: BottomTab }
  | { name: 'speaking'; mode: SpeakingMode; part?: SpeakingPart }
  | { name: 'speaking_results'; sessionId: string }

interface RouterState {
  screen: Screen
  navigateHome(): void
  navigateToTab(tab: BottomTab): void
  navigateToSpeaking(mode?: SpeakingMode, part?: SpeakingPart): void
  navigateToSpeakingResults(sessionId: string): void
}

export const useRouter = create<RouterState>((set) => ({
  screen: { name: 'home' },
  navigateHome: () => set({ screen: { name: 'home' } }),
  navigateToTab: (tab) => set({ screen: { name: tab } }),
  navigateToSpeaking: (mode: SpeakingMode = 'full_test', part?: SpeakingPart) =>
    set({ screen: { name: 'speaking', mode, part } }),
  navigateToSpeakingResults: (sessionId) =>
    set({ screen: { name: 'speaking_results', sessionId } }),
}))
